var $f8ed0031472d4b0e$exports = {};
$f8ed0031472d4b0e$exports = {
  "collapse": "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
  "expand": "\u0420\u043E\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u0438"
};
export { $f8ed0031472d4b0e$exports as default };